import React, { useState , useEffect} from "react";
import styled from "styled-components";
import ArtistServices from "../../based/services/ArtistServices"
import { FolderType } from "../Artwork/ArtworkDesktop";


function DropDownFolder({ selectedItem, setSelectedItem ,folderId, last}) {
    const [dropdown, setDropdown] = useState(true);
    const [folder, setFolder] = useState([])

    useEffect(()=>{
        getFolder()
    },[])

    const getFolder = async()=>{
        let [err, data] = await ArtistServices.GetFolderArtistByUser()
        if (!err && data && data.length > 0) {
            let filter = data.filter(x => (x.folderType == FolderType.Artwork))
            setFolder(filter)
            if(folderId == -1 && filter.length > 0)
                setSelectedItem(filter[0]);
            else{
                filter.forEach((item) => {
                    if(item.id == folderId){
                        setSelectedItem(item);
                    }
                });
            }
        } else {
            setFolder([])
        }
        
    }

    function renderDropDown() {
        if (folder) {
            return folder.map((item, index) => {
                return (
                    <div
                        key={index}
                        className={`item ${selectedItem.id == item.id ? 'active': ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            _handleClickDropdown(item)
                        }}
                    >
                        <div className="box">
                            <span className="ml-11">{item.name}</span>
                        </div>
                       
                    </div>
                );
            });
        }
    }
    function _handleClickDropdown(item) {
        setSelectedItem(item)
        setDropdown(true);
    }

    return (
        <DropDown>
            <div onClick={() => setDropdown(!dropdown)} className={dropdown ? "filter-custom" : "filter-custom click"}>
                <div className="filter-option">
                    <div className="box">
                        <span>{selectedItem.name}</span>
                    </div>
                    <div className="icon-down">
                        <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1L9 9L1 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
                        </svg>

                    </div>
                </div>
                <div className={`dropdown ${ window.innerWidth <769 && last ? "bottom": ""}`}>
                    {renderDropDown()}
                </div>
            </div>
        </DropDown>
    );
}
DropDownFolder.propTypes = {};

const DropDown = styled.div`
    .filter-custom {
        border-radius: 10px;
        width: 100%;
        position: relative;
        transition: all 0.2s ease-in;

        &.click .dropdown {
            padding-bottom: 10px;
            max-height: 1000px;
            border: 1.5px solid #06F1B9;
        }
        &.click .filter-option .icon-down {
            transform: rotate(180deg);
        }
        .mr--11 {
            margin-right: -11px;
        }
        .ml-11 {
            margin-left: 11px;
        }
        .filter-option {
            cursor: pointer;
            .box {
                border-radius: 10px;
                height: 34px;
                background-color: #313131;
                padding: 11px 16px 11px 0;
                display: flex;
                align-items: center;
                justify-content: start;
                

                .icon {
                    width: 56px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: -11px;

                    img {
                        width: auto;
                        height: auto;
                    }
                }

                span {
                    margin-left: 11px;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: -0.01em;
                    color: #fff;
                    white-space: nowrap;
                }
            }

            .icon-down {
                position: absolute;
                top: 8px;
                right: 8px;
                transition: all 0.2s ease-in;
            }
        }

        .dropdown {
            position: absolute;
            z-index: 10;
            border: none;
            border-radius: 10px;
            overflow: hidden;
            top: calc(100% + 10px);
            background-color:  #313131;
            left: 0;
            max-height: 0;
            padding-bottom: 0;
            transition: 0.2s ease-in;
            overflow: hidden;
            width: 100%;

            &.bottom{
                top: unset;
                bottom: calc(100% + 10px);
            }

            .item {
                position: relative;
                cursor: pointer;

                &.active {
                    .box {
                        background: #4e4e4e;
                    }
                }
                .box {
                    height: 40px;
                    padding: 11px 16px 11px 0;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    :hover {
                        background: #4e4e4e;
                    }

                    .icon {
                        width: 56px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: auto;
                            height: auto;
                        }
                    }

                    span {
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.01em;
                        color: #fff;

                        &.pl-11 {
                            padding-left: 11px;
                        }
                    }
                }
                .icon-down-up {
                    position: absolute;
                    top: 12px;
                    right: 8px;
                    transition: all 0.2s ease-in;
                    &.up {
                        transform: rotate(180deg);
                        ~ .nav {
                            display: block;
                        }
                    }
                }

                
            }
        }
    }
`;
export default DropDownFolder;



// WEBPACK FOOTER //
// ./src/artist-ui/components/DropDownFolder.js